import React from "react";
import Links from "./Links";
import logo from "../Grieat_logo.jpeg";

const Main =() => {
    const myLinks = [
        {title: 'YouTube', url: 'https://www.youtube.com/@radiColonAnt'},
        {title: 'Instagram', url: 'https://www.instagram.com/henri_corporation/'},
        {title: 'Tiktok', url: 'https://www.tiktok.com/@radi__ant'},
        {title: 'KaryaKarsa', url: 'https://karyakarsa.com/henrifinanceid'},
        // {title: '', url: ''},
    ];

    const affiliateLinks =[
        {title: 'HK Badminton', url: 'https://www.instagram.com/hk__badminton/'},
        {title: 'Never Not Gym [Personal PT]', url: 'https://www.tiktok.com/@ignatiusfidelisardian'},
        {title: 'HC Garage', url: 'https://www.instagram.com/hc_garage.id/'},
    ];

    return (
        <div className="main-container">
            <div className="logo-container">
                <img src={logo} alt="logo" className="logo-img" />
            </div>
            <h1>GRIEAT</h1>
            <h2>Radi:Ant & Henrich Corp</h2>
            <Links links={myLinks} />
            <h3>Affiliates</h3>
            <Links links={affiliateLinks} />
            <h6>All rights reserved by Heryanto & Kurniadhi Group, 2022</h6>
        </div>
    );
};

export default Main;